export const companySettingsDataPointUsage = "/company_settings/data_point_usage";
